import { defineComponent as _defineComponent } from 'vue'
import { useMediaAsset } from '~/composables';
import ProductContentBannerPoints from '~/components/sections/productSection/ProductContentBannerPoints.vue';

interface Props {
  data?: any;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductContentBanner',
  props: {
    data: { default: () => ({}) }
  },
  setup(__props: any) {



const { getAssetUrl } = useMediaAsset();

return { __sfc: true,getAssetUrl, ProductContentBannerPoints }
}

})